<template>
   <el-row>
    <el-col>
      <el-breadcrumb separator="/" class="admincrumb">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>营销</el-breadcrumb-item>
        <el-breadcrumb-item>展示广告</el-breadcrumb-item>
      </el-breadcrumb>
    </el-col>
     <el-col class="'toolbar">
      <el-form :inline="true" :model="s" class="form-inline" size="small">
        <el-form-item label="广告名称">
          <el-input v-model="s.showName_contains" placeholder="请输入广告位名称"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button-group>
            <el-button type="primary" @click="seacrch"><i class="el-icon-search" style="font-weight: bolder; margin-right: 6px;"></i>搜索</el-button>
            <el-button type="primary" @click="addADVShow = true"><i class="el-icon-circle-plus-outline" style="font-weight: bolder; margin-right: 6px;"></i>新增广告位</el-button>
          </el-button-group>
        </el-form-item>
      </el-form>
      <el-dialog :visible.sync="addADVShow" :before-close="handleClose" width="30%">
        <span>
            <el-form :model = "newADV" ref= "newadvform" label-width="100px" class="laddform">
              <el-form-item label="显示名称" prop="showName" :rules="{required: true, message: '显示名称不能为空', trigger: 'blur'}">
                <el-input v-model="newADV.showName" placeholder="请输入系统显示名称"></el-input>
              </el-form-item>
              <el-form-item label="广告宽度" prop="width" :rules="{required: true, message: '广告宽度不能为空', trigger: 'blur'}">
                <el-input v-model="newADV.width" placeholder="请输入广告宽度"></el-input>
              </el-form-item>
              <el-form-item label="广告高度" prop="height" :rules="{required: true, message: '广告高度不能为空', trigger: 'blur'}">
                <el-input v-model="newADV.height" placeholder="请输入广告高度"></el-input>
              </el-form-item>
              <el-form-item label="首页焦点广告" prop="name" require>
                <el-tooltip :content="'当前选择值: ' + newADV.isFocus" placement="top">
                  <el-switch
                    v-model="newADV.isFocus"
                    active-color="#13ce66"
                    inactive-color="#ff4949"
                    active-value="true"
                    inactive-value="false">
                  </el-switch>
                </el-tooltip>
              </el-form-item>
              <el-form-item>
                <el-button @click="addADVShow = false">取 消</el-button>
                <el-button type="primary" @click="applyADV('newadvform')">确 定</el-button>
              </el-form-item>
            </el-form>
          </span>
      </el-dialog>
       <el-dialog :visible.sync="upADVShow" :before-close="handleClose" width="30%">
        <span>
            <el-form :model = "currADVrow" ref= "newadvform" label-width="100px" class="laddform">
              <el-form-item label="显示名称" prop="showName" :rules="{required: true, message: '显示名称不能为空', trigger: 'blur'}">
                <el-input v-model="newADV.showName" placeholder="请输入系统显示名称"></el-input>
              </el-form-item>
              <el-form-item label="广告宽度" prop="width" :rules="{required: true, message: '广告宽度不能为空', trigger: 'blur'}">
                <el-input v-model="newADV.width" placeholder="请输入广告宽度"></el-input>
              </el-form-item>
              <el-form-item label="广告高度" prop="height" :rules="{required: true, message: '广告高度不能为空', trigger: 'blur'}">
                <el-input v-model="newADV.height" placeholder="请输入广告高度"></el-input>
              </el-form-item>
              <el-form-item label="首页焦点广告" prop="name" require>
                <el-tooltip :content="'当前选择值: ' + newADV.isFocus" placement="top">
                  <el-switch
                    v-model="newADV.isFocus"
                    active-color="#13ce66"
                    inactive-color="#ff4949"
                    active-value="true"
                    inactive-value="false">
                  </el-switch>
                </el-tooltip>
              </el-form-item>
              <el-form-item>
                <el-button @click="addADVShow = false">取 消</el-button>
                <el-button type="primary" @click="applyADV('newadvform')">确 定</el-button>
              </el-form-item>
            </el-form>
          </span>
      </el-dialog>
    </el-col>
     <el-col :span="24">
       <el-col>
         <el-table
            :data="currAdvseat"
            stripe
            style="width: 100%">
            <el-table-column
              prop="ID"
              label="广告编号"
              width="80">
            </el-table-column>
            <el-table-column
              prop="adKey"
              label="广告位指纹"
              width="300">
            </el-table-column>
            <el-table-column
              prop="showName"
              label="广告位名称" width="420">
            </el-table-column>
           <el-table-column
              prop="width"
              label="广告位宽度">
            </el-table-column>
           <el-table-column
              prop="height"
              label="广告位高度">
            </el-table-column>
           <el-table-column
              prop="height"
              label="首页海报" :formatter="chkfocus">
            </el-table-column>
           <el-table-column
              prop="height"
              label="广告位状态" :formatter="advstste">
            </el-table-column>
           <el-table-column fixed="right" label="操作" width="360">
                <template slot-scope="scope">
                  <el-button type="text" size="small" @click="editCurrAdvSeat(scope.row)">编辑</el-button>
                  <el-button type="text" size="small" @click="makefocus(scope.row)">首页海报</el-button>
                  <el-button @click="handleAdvStateChange(scope.row)" type="text" size="small">状态</el-button>
                  <el-button @click="advshow(scope.row)" type="text" size="small">广告管理</el-button>
                </template>
              </el-table-column>
          </el-table>
       </el-col>
       <el-col :span="24" class="pagenav" style="margin-top: 42px;">
          <el-pagination
          @current-change="handleCurrentAdvChange"
          :current-page="currAdvseatPage.page"
          :page-sizes="[12]"
          :page-size="12"
          layout="total, sizes, prev, pager, next, jumper"
          :total="currAdvseatPage.total">
        </el-pagination>
      </el-col>
       <el-dialog :visible.sync="addADVAdvContentShow" :before-close="handleClose" fullscreen="true">
         <el-col class="'toolbar">
           <el-form :inline="true" :model="a" class="form-inline" size="small">
            <el-form-item label="广告名称">
              <el-input v-model="a.title_contains" placeholder="请输入广告名称"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button-group>
                <el-button type="primary" @click="seacrch"><i class="el-icon-search" style="font-weight: bolder; margin-right: 6px;"></i>搜索</el-button>
                <el-button type="primary" @click="makeadsapply"><i class="el-icon-circle-plus-outline" style="font-weight: bolder; margin-right: 6px;"></i>新增广告</el-button>
              </el-button-group>
            </el-form-item>
          </el-form>
         </el-col>
         <el-col :span="24" class="adspage">
           <el-table
            :data="currAdsPageList"
            stripe
            style="width: 100%">
            <el-table-column
              prop="ID"
              label="广告编号"
              width="80">
            </el-table-column>
            <el-table-column
              prop="fingerCode"
              label="广告指纹"
              width="300">
            </el-table-column>
            <el-table-column
              prop="title"
              label="广告位名称" width="420">
            </el-table-column>
           <el-table-column
              prop="jumpUrl"
              label="跳转地址">
            </el-table-column>
           <el-table-column
              prop="content"
              label="文案">
             <template slot-scope="scope">
               <div v-html="scope.row.content"></div>
             </template>
            </el-table-column>
             <el-table-column
              prop="cover"
              label="封面" :formatter="adscover">
               <template slot-scope="scope">
                 <img class="tablecover" :src="scope.row.cover"/>
               </template>
            </el-table-column>
           <el-table-column
              prop="startTime"
              label="开始时间" :formatter="adsstarttime">
            </el-table-column>
           <el-table-column
              prop="endTime"
              label="结束时间" :formatter="adsendtime">
            </el-table-column>
             <el-table-column
              prop="height"
              label="广告状态" :formatter="adstste">
            </el-table-column>
           <el-table-column fixed="right" label="操作" width="360">
                <template slot-scope="scope">
                  <el-button type="text" size="small" @click="editCurrAdsState(scope.row)">状态</el-button>
                  <el-button type="text" size="small" @click="editCurrAds(scope.row)">编辑</el-button>
                </template>
              </el-table-column>
          </el-table>
         </el-col>
         <el-col :span="24" class="pagenav" style="margin-top: 42px;">
            <el-pagination
            @current-change="handleCurrentAdvChange"
            :current-page="currAdsPage.page"
            :page-sizes="[12]"
            :page-size="12"
            layout="total, sizes, prev, pager, next, jumper"
            :total="currAdsPage.total">
          </el-pagination>
        </el-col>
       </el-dialog>
       <el-dialog title="新增广告排期" :visible.sync="addadsShow">
         <el-form :model = "newAds" ref= "newadvform" label-width="100px" class="laddform">
              <el-form-item label="显示名称" prop="title" :rules="{required: true, message: '显示名称不能为空', trigger: 'blur'}">
                <el-input v-model="newAds.title" placeholder="请输入系统显示名称"></el-input>
              </el-form-item>
             <el-form-item label="跳转地址" prop="jumpUrl" :rules="{required: true, message: '跳转地址不能为空', trigger: 'blur'}">
                <el-input v-model="newAds.jumpUrl" placeholder="请输入跳转地址"></el-input>
              </el-form-item>
              <el-form-item label="广告图片" prop="cover" :rules="{required: true, message: '广告图片不能为空', trigger: 'blur'}">
                <el-upload
                  :span="24"
                  class="adscoverupload"
                  :data="uploadattr"
                  name="upload"
                  accept="image/*"
                  :headers="$verifyhead"
                  :action="currUpurl"
                  :show-file-list="false"
                  :on-success="handleCoverSuccess">
                  <img v-if="newAds.cover" :src="newAds.cover" class="avatar">
                  <i v-else class="el-icon-plus avatar-uploader-icon" style="width: 100%!important;"></i>
                </el-upload>
                <el-input v-model="newAds.cover" placeholder="请输入广告图片" style="display: none;"></el-input>
              </el-form-item>
              <el-form-item label="开始时间" prop="startTime" :rules="{required: true, message: '广告开始时间不能为空', trigger: 'blur'}">
                <el-date-picker
                  v-model="newAds.startTime"
                  type="datetime"
                  placeholder="选择开始日期时间"
                  :change="getStart"
                  align="right">
                </el-date-picker>
              </el-form-item>
              <el-form-item label="结束时间" prop="endTime" :rules="{required: true, message: '广告结束时间不能为空', trigger: 'blur'}">
                <el-date-picker
                  v-model="newAds.endTime"
                  type="datetime"
                  placeholder="选择结束日期时间"
                  :change="getEnd"
                  align="right">
                </el-date-picker>
              </el-form-item>
              <el-form-item label="广告跟踪码" prop="trackCode" :rules="{required: true, message: '广告跟踪码不能为空', trigger: 'blur'}">
                <el-input v-model="newAds.trackCode" placeholder="请输入广告跟踪码"></el-input>
              </el-form-item>
              <el-form-item label="广告文字" prop="content" :rules="{required: true, message: '文字内容不能为空', trigger: 'blur'}">
                <vue-editor v-model="newAds.content" style="height: 320px; overflow-y: auto;"></vue-editor>
              </el-form-item>
              <el-form-item>
                <el-button @click="addadsShow = false">取 消</el-button>
                <el-button type="primary" @click="applyAds('newadvform')">确 定</el-button>
              </el-form-item>
            </el-form>
       </el-dialog>
       <el-dialog title="编辑广告排期" :visible.sync="upADVShow" :before-close="handleClose" width="60%">
        <span>
            <el-form :model = "currADVrow" ref= "editadvform" label-width="100px" class="laddform">
              <el-form-item label="显示名称" prop="title" :rules="{required: true, message: '显示名称不能为空', trigger: 'blur'}">
                <el-input v-model="currADVrow.title" placeholder="请输入系统显示名称"></el-input>
              </el-form-item>
             <el-form-item label="跳转地址" prop="jumpUrl" :rules="{required: true, message: '跳转地址不能为空', trigger: 'blur'}">
                <el-input v-model="currADVrow.jumpUrl" placeholder="请输入跳转地址"></el-input>
              </el-form-item>
              <el-form-item label="广告图片" prop="cover" :rules="{required: true, message: '广告图片不能为空', trigger: 'blur'}">
                <el-upload
                  :span="24"
                  class="adscoverupload"
                  :data="uploadattr"
                  name="upload"
                  :headers="$verifyhead"
                  accept="image/*"
                  :action="currUpurl"
                  :show-file-list="false"
                  :on-success="handleEditCoverSuccess">
                  <img v-if="currADVrow.cover" :src="currADVrow.cover" class="avatar">
                  <i v-else class="el-icon-plus avatar-uploader-icon" style="width: 100%!important;"></i>
                </el-upload>
                <el-input v-model="currADVrow.cover" placeholder="请输入广告图片" style="display: none;"></el-input>
              </el-form-item>
              <el-form-item label="开始时间" prop="startTime" :rules="{required: true, message: '广告开始时间不能为空', trigger: 'blur'}">
                <el-date-picker
                  v-model="currADVrow.startTime"
                  type="datetime"
                  placeholder="选择开始日期时间"
                  :change="getEditStart"
                  align="right">
                </el-date-picker>
              </el-form-item>
              <el-form-item label="结束时间" prop="endTime" :rules="{required: true, message: '广告结束时间不能为空', trigger: 'blur'}">
                <el-date-picker
                  v-model="currADVrow.endTime"
                  type="datetime"
                  placeholder="选择结束日期时间"
                  :change="getEditEnd"
                  align="right">
                </el-date-picker>
              </el-form-item>
              <el-form-item label="广告跟踪码" prop="trackCode" :rules="{required: true, message: '广告跟踪码不能为空', trigger: 'blur'}">
                <el-input v-model="currADVrow.trackCode" placeholder="请输入广告跟踪码"></el-input>
              </el-form-item>
              <el-form-item label="广告文字" prop="content" :rules="{required: true, message: '文字内容不能为空', trigger: 'blur'}">
                <vue-editor v-model="currADVrow.content" style="height: 320px; overflow-y: auto;"></vue-editor>
              </el-form-item>
              <el-form-item>
                <el-button @click="upADVShow = false">取 消</el-button>
                <el-button type="primary" @click="applyEditAds('editadvform')">确 定</el-button>
              </el-form-item>
            </el-form>
          </span>
      </el-dialog>
     </el-col>
   </el-row>
</template>
<script>
import ElCol from 'element-ui/packages/col/src/col'
import ElRow from 'element-ui/packages/row/src/row'
import E from 'wangeditor'
export default{
  components: {
    ElRow,
    ElCol
  },
  name: 'Advertisement',
  data () {
    return {
      addADVShow: false,
      s: {},
      a: {},
      newADV: {isFocus: false},
      currAdvseat: [],
      currAdvseatPage: {},
      addADVAdvContentShow: false,
      addadsShow: false,
      newAds: {},
      currUpurl: this.$apiurl,
      adscontentnotify: '请输入你需要的广告文字',
      uploadattr: {method: 'base.upload'},
      currEditorADV: {},
      currAdsPage: {},
      adsKey: {},
      currAdsPageList: [],
      upADVShow: false,
      currADVrow: {}
    }
  },
  computed: {
    editor () {
      return this.$refs.adseditor.quillEditor
    }
  },
  mounted: function () {
    var that = this
    this.handleCurrentAdvChange(1)
    var editor = new E(this.$refs.editor)
    editor.customConfig.onchange = (html) => {
      that.$set(that.newAds, 'content', html)
    }
    editor.create()
  },
  methods: {
    imgLoad: function (file, Editor, cursorLocation, resetUploader) {
      var foemData = new FormData()
      foemData.append('upload', file)
      var api = this.upurl
      var that = this
      that.$http.post(api, foemData).then(function (ret) {
        var imgurl = 'https:' + ret.body.data.url
        Editor.insertEmbed(cursorLocation, 'image', imgurl)
      })
    },
    handleClose (done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          done()
        })
        .catch(_ => {})
    },
    covershow: function (data) {

    },
    handleClick (tab, event) {
      console.log(tab, event)
    },
    adsstarttime: function (data) {
      var d = new Date(data.startTime)
      return (d.toLocaleString())
    },
    adsendtime: function (data) {
      var d = new Date(data.startTime)
      return (d.toLocaleString())
    },
    applyADV: function (formName) {
      var that = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          var params = that.newADV
          params['method'] = 'shop.addAdv'
          that.$http.post(that.$apiurl, params).then(function (ret) {
            if (ret.body.data.code === 200) {
              that.$message.success('用户新广告位设置成功!')
              that.addADVShow = false
              that.handleCurrentAdvChange(1)
            } else {
              that.$alert('广告位申请失败，请稍后重试!')
            }
          })
        } else {
          that.$alert('请检查表格项是否正确填写!')
        }
      })
    },
    seacrch: function () {

    },
    handleCurrentAdvChange: function (page) {
      var data = this.s
      data['page'] = page
      data['num'] = 20
      data['method'] = 'shop.advpage'
      var that = this
      this.$http.post(that.$apiurl, data).then(function (ret) {
        that.$set(that.currAdvseatPage, 'page', ret.body.data.page)
        that.$set(that.currAdvseatPage, 'total', ret.body.data.total)
        that.currAdvseat = ret.body.data.data
      })
    },
    loadAds: function (page) {
      var data = this.adsKey
      data['page'] = page
      data['num'] = 20
      data['method'] = 'shop.adsPage'
      data['adv__ID'] = this.currEditorADV.ID
      var that = this
      this.$http.post(that.$apiurl, data).then(function (ret) {
        that.$set(that.currAdsPage, 'page', ret.body.data.page)
        that.$set(that.currAdsPage, 'total', ret.body.data.total)
        that.currAdsPageList = ret.body.data.data
      })
    },
    chkfocus: function (data) {
      if (data.isFocus) {
        return ('首页海报广告')
      } else {
        return ('普通展示广告')
      }
    },
    advstste: function (data) {
      if (data.status) {
        return ('启用')
      } else {
        return ('禁用')
      }
    },
    adstste: function (data) {
      if (data.status) {
        return ('启用')
      } else {
        return ('禁用')
      }
    },
    advshow: function (row) {
      this.currEditorADV = row
      this.addADVAdvContentShow = true
      this.loadAds(1)
    },
    handleCoverSuccess: function (response, file, fileList) {
      var that = this
      this.$set(that.newAds, 'cover', response.data.url)
    },
    handleEditCoverSuccess: function (response, file, fileList) {
      var that = this
      this.$set(that.currADVrow, 'cover', response.data.url)
    },
    getStart: function (data) {
      var that = this
      this.$set(that.newAds, 'startTime', data)
    },
    getEnd: function (data) {
      var that = this
      this.$set(that.newAds, 'endTime', data)
    },
    getEditStart: function (data) {
      var that = this
      this.$set(that.currADVrow, 'startTime', data)
    },
    getEditEnd: function (data) {
      var that = this
      this.$set(that.currADVrow, 'endTime', data)
    },
    applyAds: function (formName) {
      var that = this
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          var data = {parmas: JSON.stringify(that.newAds)}
          data['adID'] = that.currEditorADV.ID
          data['method'] = 'shop.adsinsert'
          that.$http.post(that.$apiurl, data).then(function (ret) {
            if (ret.body.data.code === 200) {
              that.$message.success('广告内容提交成功!')
              that.loadAds(1)
            } else {
              that.$alert('广告信息提交失败，请稍后重试!')
            }
          })
        } else {
          that.$alert('请认真检查是否有正确填写表单!')
        }
      })
    },
    makeadsapply: function (row) {
      this.addadsShow = true
    },
    handleAdvStateChange: function (row) {
      console.log(row)
      var qd = {}
      qd.aid = row.ID
      qd.method = 'shop.advstate'
      var that = this
      that.$http.post(that.$apiurl, qd).then(function (ret) {
        if (ret.body.data.code === 200) {
          that.$message.success('广告状态修改成功!')
          that.handleCurrentAdvChange(1)
        } else {
          that.$alert('广告状态修改失败，请稍后重试!')
        }
      })
    },
    editCurrAds: function (row) {
      var that = this
      that.upADVShow = true
      that.currADVrow = row
    },
    applyEditAds: function (formname) {
      var that = this
      that.$refs[formname].validate(function (valid) {
        if (valid) {
          var data = that.currADVrow
          data.method = 'shop.changradvcontent'
          that.$http.post(that.$apiurl, data).then(function (ret) {
            if (ret.body.data.code === 200) {
              that.$message.success('广告修改成功!')
              that.upADVShow = false
              that.loadAds(1)
            } else {
              that.$alert('广告修改失败，请稍后重试!')
            }
          })
        }
      })
    },
    editCurrAdsState: function (row) {
      var qd = {}
      qd.aid = row.ID
      qd.method = 'shop.adstate'
      var that = this
      that.$http.post(that.$apiurl, qd).then(function (ret) {
        if (ret.body.data.code === 200) {
          that.$message.success('广告状态修改成功!')
          that.loadAds(1)
        } else {
          that.$alert('广告状态修改失败，请稍后重试!')
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/market/Advertisement.vue